import { render, staticRenderFns } from "./DictItemList.vue?vue&type=template&id=563e56b8&scoped=true"
import script from "./DictItemList.vue?vue&type=script&lang=js"
export * from "./DictItemList.vue?vue&type=script&lang=js"
import style0 from "./DictItemList.vue?vue&type=style&index=0&id=563e56b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563e56b8",
  null
  
)

export default component.exports